import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { SettingsService } from "./site-settings.service";

export const SiteSettingsResolver: ResolveFn<any> = () => {
  const service = inject(SettingsService);
  return service.getSiteSettings();
}
